'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _mergeWith2 = require('lodash/mergeWith');

var _mergeWith3 = _interopRequireDefault(_mergeWith2);

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ApiService.$inject = ['$window', '$timeout', '$log', '$rootScope'];


var _ = {
    mergeWith: _mergeWith3.default,
    merge: _merge3.default
};

var _module = _angular2.default.module('cb.api.service', []);

_module.service('ApiService', ApiService);

exports.default = _module;


function ApiService($window, $timeout, $log, $rootScope) {
    var cbObject = $window['CentraalBeheerObject'] || 'cb';
    var cb = $window[cbObject] || {};
    var api = {};
    var cmdQueue = [];

    init();

    return {
        attach: attach,
        registerGettersAndSetters: registerGettersAndSetters
    };

    function invokeCmd(argv) {
        var fn = api,
            i = 0;

        // Find function to invoke in api object.
        while (fn = fn[argv[i++]]) {
            if (typeof fn === 'function') {
                break;
            } else if ((typeof fn === 'undefined' ? 'undefined' : (0, _typeof3.default)(fn)) === 'object') {
                // If an array is found and no index is given, get the first item in the array.
                if (typeof fn.length !== 'undefined' && typeof argv[i] !== 'number') {
                    fn = fn[0];
                    break;
                }
            } else {
                //$log.log('cmd ' + argv[i] + ' unknown type');
                return false;
            }
        }

        // Call function with the rest of the arguments.
        if (typeof fn === 'function') {
            fn.apply(this, Array.prototype.slice.call(argv, i));
            return true;
        } else {
            //$log.log('cmd ' + argv[i - 1] + ' not found');
            return false;
        }
    }

    function registerGettersAndSetters(gettersAndSetters) {
        var set = function set(obj) {
            _.merge(gettersAndSetters, obj);
        };

        var get = function get(callback) {
            if (typeof callback === 'function') {
                callback(gettersAndSetters);
            } else {
                $log.log(gettersAndSetters);
            }
        };

        return {
            get: get,
            set: set
        };
    }

    function init() {
        // Save command queue to array.
        cmdQueue = cb.q || [];

        // Replace command queue push function with a function that immediately runs commands.
        cmdQueue.push = invokeCmd;

        cb = $window[cbObject] = function () {
            invokeCmd(arguments);

            if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                $rootScope.$apply();
            }
        };

        // Run already queued commands.
        $timeout(function () {
            for (var i = 0; i < cmdQueue.length; i++) {
                if (invokeCmd(cmdQueue[i])) {
                    cmdQueue.splice(i, 1);
                    i--;
                }
            }
        });

        cb.api = api;
    }

    /**
     * @ngdoc function
     * @name ApiService#attach
     */
    function attach(functions) {
        _.mergeWith(api, functions, function (objValue, srcValue) {
            if (typeof objValue === 'undefined') {
                // New function or object does not exist yet: add to API
                return srcValue;
            } else if (typeof objValue === 'function') {
                // New function already exists: indexed add to API
                return [objValue, srcValue];
            } else {
                if (typeof objValue.length !== 'undefined') {
                    // Adding an object: overwrite
                    return objValue.concat(srcValue);
                } else {
                    return undefined;
                }
            }
        });

        // Run already queued commands.
        $timeout(function () {
            for (var i = 0; i < cmdQueue.length; i++) {
                if (invokeCmd(cmdQueue[i])) {
                    cmdQueue.splice(i, 1);
                    i--;
                }
            }
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/api/api.service.js
// module id = 768
// module chunks = 0